import { tienePermiso } from '../../../utils/permisosUtil';

export const registroDatosMixin = {
  computed: {
    permisosRegistroDatos() {
      return {
        accesoModulo: tienePermiso('novedades'),
        registrarDatos: tienePermiso('registerData'),
        puedeRegistrarEmpleado: tienePermiso('registerEmployee'),
        editarEmpleado: tienePermiso('editEmployee'),
        bloquearEmpleado: tienePermiso('blockEmployee'),
        puedeVerSalario: tienePermiso('seeSalary'),
      };
    },
  },
};
